import { PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { ActionIcon, Button, Table, Title } from '@mantine/core';
import cn from 'clsx';
import { useNavigate } from 'react-router-dom';

import { DeletePublisherModal } from '@/features/delete-publisher-modal';
import { RouteList } from '@/shared/constants';
import { useProjectPath } from '@/shared/projects/project-path';
import { usePublishersStore } from '@/shared/stores/publishers.store';

import { useGetPublishers } from '../model/publishers-page.cases';
import styles from './publishers-page.module.scss';

export const PublishersPage = () => {
  const navigate = useNavigate();
  const withProject = useProjectPath();
  const getPublishersQuery = useGetPublishers();
  const setDeletablePublisher = usePublishersStore(
    (state) => state.setDeletablePublisher,
  );

  return (
    <div className={styles.container}>
      <Title order={1} size={44} className={styles.title}>
        Издательства
      </Title>
      <div className={styles.header}>
        <Button
          size="lg"
          leftSection={<PlusIcon width={20} height={20} />}
          onClick={() => navigate(withProject(RouteList.CREATE_PUBLISHER))}
        >
          Добавить издательство
        </Button>
      </div>
      <DeletePublisherModal />
      <Table.ScrollContainer minWidth="100%" className={styles.table}>
        <Table withTableBorder flex={1}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th
                className={cn(styles.tableHeadCell, styles.publisherHeadCell)}
              >
                Название
              </Table.Th>
              <Table.Th className={styles.tableHeadCell}>Обложка</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {getPublishersQuery.data.publishers.map((publisher) => (
              <Table.Tr key={publisher.id} className={styles.tableRow}>
                <Table.Td
                  width="50%"
                  className={styles.publisherTitleCell}
                  onClick={() =>
                    navigate(
                      withProject(
                        RouteList.PUBLISHER_DETAILS(String(publisher.id)),
                      ),
                    )
                  }
                >
                  {publisher.title}
                </Table.Td>
                <Table.Td width="40%">
                  {publisher.imgUrl && (
                    <img
                      src={publisher.imgUrl}
                      alt={publisher.title}
                      className={styles.publisherPreviewImage}
                    />
                  )}
                </Table.Td>
                <Table.Td width="10%">
                  <div className={styles.actions}>
                    <ActionIcon
                      variant="subtle"
                      size="lg"
                      color="gray"
                      onClick={() =>
                        navigate(
                          withProject(
                            RouteList.EDIT_PUBLISHER(String(publisher.id)),
                          ),
                        )
                      }
                    >
                      <PencilIcon width={24} height={24} />
                    </ActionIcon>
                    <ActionIcon
                      variant="subtle"
                      size="lg"
                      color="gray"
                      onClick={() =>
                        setDeletablePublisher({
                          id: publisher.id,
                          title: publisher.title,
                        })
                      }
                    >
                      <TrashIcon width={24} height={24} />
                    </ActionIcon>
                  </div>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </div>
  );
};
